// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Select Category Page Styles */

.modern-select-category-page {
  min-height: 100vh;
  background: #ffffff;
  padding: 1rem;
}

.modern-select-category-page__container {
  max-width: 1200px;
  margin: 0 auto;
}

.modern-select-category-page__header {
  text-align: center;
  margin-bottom: 2rem;
}

.modern-select-category-page__icon {
  font-size: 4rem;
  color: #00d4aa;
  margin-bottom: 1rem;
}

.modern-select-category-page__title {
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.75rem;
}

.modern-select-category-page__description {
  font-size: 1.125rem;
  color: #374151;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.modern-select-category-page__search {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}

.modern-select-category-page__search-container {
  position: relative;
  max-width: 400px;
  width: 100%;
}

.modern-select-category-page__search-input {
  width: 100%;
  padding: 0.75rem 3rem 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: #ffffff;
}

.modern-select-category-page__search-input:focus {
  border-color: #00d4aa;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 212, 170, 0.1);
}

.modern-select-category-page__search-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 1.125rem;
}

.modern-select-category-page__controls {
  margin-bottom: 1.5rem;
  text-align: center;
}

.modern-select-category-page__mode-text {
  font-size: 0.875rem;
  color: #6b7280;
  font-style: italic;
}

.modern-select-category-page__selection-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.5rem;
}

.modern-select-category-page__selection-count {
  font-size: 0.875rem;
  font-weight: 600;
  color: #047857;
  padding: 0.25rem 0.75rem;
  background: #d1fae5;
  border-radius: 9999px;
}

.modern-select-category-page__proceed-btn {
  padding: 0.5rem 1rem;
  background: #00d4aa;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.modern-select-category-page__proceed-btn:hover {
  background: #059669;
}

.modern-select-category-page__clear-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.modern-select-category-page__clear-btn:hover {
  background: #f9fafb;
  border-color: #00d4aa;
}

.modern-select-category-page__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.modern-category-card {
  background: #ffffff;
  border: 2px solid transparent;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  position: relative;
}

.modern-category-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-color: #a7f3d0;
}

.modern-category-card--selected {
  border-color: #00d4aa;
  background: #ecfdf5;
}

.modern-category-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.modern-category-card__checkbox {
  width: 18px;
  height: 18px;
  accent-color: #00d4aa;
  cursor: pointer;
}

.modern-category-card__icon {
  font-size: 2rem;
  opacity: 0.7;
}

.modern-category-card__content {
  flex: 1;
  margin-bottom: 1rem;
}

.modern-category-card__name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
}

.modern-category-card--selected .modern-category-card__name {
  color: #047857;
}

.modern-category-card__description {
  font-size: 0.875rem;
  color: #374151;
  margin-bottom: 0.75rem;
  line-height: 1.6;
}

.modern-category-card__rank {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 0.75rem;
  border-radius: 9999px;
}

.modern-category-card__action {
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #9ca3af;
  transition: all 0.15s ease-in-out;
}

.modern-category-card:hover .modern-category-card__action {
  color: #00d4aa;
  transform: translateX(2px);
}

.modern-select-category-page__footer {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.modern-select-category-page__skip-btn {
  background: transparent;
  color: #6b7280;
  border: none;
  padding: 0.75rem 1rem;
  text-decoration: underline;
  cursor: pointer;
}

.modern-select-category-page__skip-btn:hover {
  color: #374151;
  background: #f9fafb;
  text-decoration: none;
}

.modern-select-category-page__no-results {
  text-align: center;
  padding: 2rem;
  grid-column: 1 / -1;
}

.modern-select-category-page__no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.modern-select-category-page__no-results-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.modern-select-category-page__no-results-text {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.modern-select-category-page__clear-search-btn {
  padding: 0.5rem 1rem;
  background: #6366f1;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.modern-select-category-page__clear-search-btn:hover {
  background: #4f46e5;
}

/* Legacy styles (hidden) */
.rct-select-category-page,
.rct-select-category {
  display: none;
}

/* Mobile responsive */
@media (max-width: 640px) {
  .modern-select-category-page {
    padding: 0.75rem;
  }

  .modern-select-category-page__grid {
    grid-template-columns: 1fr;
  }

  .modern-category-card {
    padding: 1rem;
  }

  .modern-select-category-page__selection-actions {
    flex-direction: column;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/select-category-page/_styles-css.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":["/* Modern Select Category Page Styles */\n\n.modern-select-category-page {\n  min-height: 100vh;\n  background: #ffffff;\n  padding: 1rem;\n}\n\n.modern-select-category-page__container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.modern-select-category-page__header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.modern-select-category-page__icon {\n  font-size: 4rem;\n  color: #00d4aa;\n  margin-bottom: 1rem;\n}\n\n.modern-select-category-page__title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #111827;\n  margin-bottom: 0.75rem;\n}\n\n.modern-select-category-page__description {\n  font-size: 1.125rem;\n  color: #374151;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.modern-select-category-page__search {\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n\n.modern-select-category-page__search-container {\n  position: relative;\n  max-width: 400px;\n  width: 100%;\n}\n\n.modern-select-category-page__search-input {\n  width: 100%;\n  padding: 0.75rem 3rem 0.75rem 1rem;\n  font-size: 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  background: #ffffff;\n}\n\n.modern-select-category-page__search-input:focus {\n  border-color: #00d4aa;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 212, 170, 0.1);\n}\n\n.modern-select-category-page__search-icon {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 1.125rem;\n}\n\n.modern-select-category-page__controls {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.modern-select-category-page__mode-text {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.modern-select-category-page__selection-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  border-radius: 0.5rem;\n}\n\n.modern-select-category-page__selection-count {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #047857;\n  padding: 0.25rem 0.75rem;\n  background: #d1fae5;\n  border-radius: 9999px;\n}\n\n.modern-select-category-page__proceed-btn {\n  padding: 0.5rem 1rem;\n  background: #00d4aa;\n  color: #ffffff;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.modern-select-category-page__proceed-btn:hover {\n  background: #059669;\n}\n\n.modern-select-category-page__clear-btn {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n}\n\n.modern-select-category-page__clear-btn:hover {\n  background: #f9fafb;\n  border-color: #00d4aa;\n}\n\n.modern-select-category-page__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.modern-category-card {\n  background: #ffffff;\n  border: 2px solid transparent;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n  position: relative;\n}\n\n.modern-category-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border-color: #a7f3d0;\n}\n\n.modern-category-card--selected {\n  border-color: #00d4aa;\n  background: #ecfdf5;\n}\n\n.modern-category-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.modern-category-card__checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #00d4aa;\n  cursor: pointer;\n}\n\n.modern-category-card__icon {\n  font-size: 2rem;\n  opacity: 0.7;\n}\n\n.modern-category-card__content {\n  flex: 1;\n  margin-bottom: 1rem;\n}\n\n.modern-category-card__name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 0.5rem;\n}\n\n.modern-category-card--selected .modern-category-card__name {\n  color: #047857;\n}\n\n.modern-category-card__description {\n  font-size: 0.875rem;\n  color: #374151;\n  margin-bottom: 0.75rem;\n  line-height: 1.6;\n}\n\n.modern-category-card__rank {\n  display: inline-block;\n  padding: 0.125rem 0.5rem;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-size: 0.75rem;\n  border-radius: 9999px;\n}\n\n.modern-category-card__action {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  color: #9ca3af;\n  transition: all 0.15s ease-in-out;\n}\n\n.modern-category-card:hover .modern-category-card__action {\n  color: #00d4aa;\n  transform: translateX(2px);\n}\n\n.modern-select-category-page__footer {\n  text-align: center;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modern-select-category-page__skip-btn {\n  background: transparent;\n  color: #6b7280;\n  border: none;\n  padding: 0.75rem 1rem;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.modern-select-category-page__skip-btn:hover {\n  color: #374151;\n  background: #f9fafb;\n  text-decoration: none;\n}\n\n.modern-select-category-page__no-results {\n  text-align: center;\n  padding: 2rem;\n  grid-column: 1 / -1;\n}\n\n.modern-select-category-page__no-results-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.modern-select-category-page__no-results-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.modern-select-category-page__no-results-text {\n  font-size: 1rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.modern-select-category-page__clear-search-btn {\n  padding: 0.5rem 1rem;\n  background: #6366f1;\n  color: #ffffff;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.modern-select-category-page__clear-search-btn:hover {\n  background: #4f46e5;\n}\n\n/* Legacy styles (hidden) */\n.rct-select-category-page,\n.rct-select-category {\n  display: none;\n}\n\n/* Mobile responsive */\n@media (max-width: 640px) {\n  .modern-select-category-page {\n    padding: 0.75rem;\n  }\n\n  .modern-select-category-page__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .modern-category-card {\n    padding: 1rem;\n  }\n\n  .modern-select-category-page__selection-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
